import styles from './productDetail.module.css'
import ReactDOM from "react-dom";
import {useState} from "react";

const ProductDetail = (props) =>
{
	const name = props.name;
	const imageUrl = props.imageUrl;
	const description = props.description;
	const price = props.price;
	const weight = props.weight;
	const type = props.type
	const close = () => {
		props.onClose()
		console.log('close')
	}

	return ReactDOM.createPortal(
		(<>
			<div className={styles.outerContainer}>
				<div className={styles.overlay} onClick={close}></div>
				<div className={styles.content}>
					<div className={styles.container}>
						<div className={styles.image}>
							<img src={imageUrl}  alt=""/>
						</div>
						<div className={styles.description}>
							<h1 className={styles.heading}>{name}</h1>
							<p className={styles.summary}>{description}</p>
							<h2 className={styles.secondaryHeading}>Summary</h2>
							<div><span className={styles.title}>Name: </span><span>{name}</span></div>
							<div><span className={styles.title}>Type: </span><span>{type}</span></div>
							<div><span className={styles.title}>Weight: </span><span>{weight} g</span></div>
							<div><span className={styles.title}>Price: </span><span>{price} INR</span></div>

						</div>
					</div>
					<button className={styles.closebtn} onClick={close}>X</button>
				</div>
			</div>
		</>),
		document.getElementById('portal')
	)
}

export default ProductDetail;